/**
 * Placeholder inserted as an ICU value, then replaced with the current
 * structured starter labels after translation has chosen its position.
 */
export const PROJECTS_STARTER_BUNDLE_ITEMS_PLACEHOLDER =
  '__HEIDI_PROJECTS_STARTER_ITEMS__';

/**
 * Near-miss remnants of the placeholder — a translation that drops or doubles
 * the outer underscores, or changes case — must never reach clinician-visible
 * composer text.
 */
const STRAY_PLACEHOLDER_PATTERN = /_{0,2}HEIDI_PROJECTS_STARTER_ITEMS_{0,2}/gi;

const collapseSpaces = (text: string): string => text.replace(/ {2,}/g, ' ').trim();

/**
 * Substitute the structured starter labels into a translated lead-in.
 *
 * Shared by the composer serializer (`projectsComposerStarterBundleText`) and
 * the verbatim-launch matcher (`existingWorkProjectIdForVerbatimLaunch`) so the
 * two derivations cannot drift apart. A well-formed placeholder positions the
 * labels; a mangled one is stripped rather than leaked; no placeholder appends
 * the labels after the lead-in.
 */
export const substituteStarterBundleItems = (leadIn: string, labels: string): string => {
  if (leadIn.includes(PROJECTS_STARTER_BUNDLE_ITEMS_PLACEHOLDER)) {
    // Replacement-callback form so `$&` and friends in labels stay literal.
    const substituted = leadIn.replace(
      PROJECTS_STARTER_BUNDLE_ITEMS_PLACEHOLDER,
      () => labels
    );
    // Empty labels leave a gap where the placeholder sat — collapse it.
    return labels ? substituted.trim() : collapseSpaces(substituted);
  }
  const sanitized = collapseSpaces(leadIn.replace(STRAY_PLACEHOLDER_PATTERN, ''));
  if (!labels) return sanitized;
  return sanitized ? `${sanitized} ${labels}` : labels;
};
